import React from 'react'
import styles from './MediaView.module.scss'
import { useFrostTheme } from '../theme/frost'
import CloseIcon from '@mui/icons-material/Close'
import LightModeIcon from '@mui/icons-material/LightMode'
import DarkModeIcon from '@mui/icons-material/DarkMode'

// The round buttons in Media's corner, as elsewhere on the site: day/night and close.
export default function MediaCorner({ onClose }) {
  const [theme, toggleTheme] = useFrostTheme()
  return (
    <div className={styles.corner}>
      <button className={styles.roundBtn} onClick={toggleTheme} title={theme === 'dark' ? 'Light mode' : 'Dark mode'} aria-label="Toggle light or dark mode">
        {theme === 'dark' ? <LightModeIcon /> : <DarkModeIcon />}
      </button>
      <button className={styles.roundBtn} onClick={onClose} title="Close" aria-label="Close"><CloseIcon /></button>
    </div>
  )
}
